<template>
  <div>
    <b-modal id="confirmaSemDadosBancarios" ref="confirmaSemDadosBancarios" size="x1" title="Atenção" no-close-on-backdrop
      no-close-on-esc hide-header-close hide-footer>
      <template #modal-header>
        <h5>Atenção</h5>
      </template>
      Para conclusão do seu cadastro, favor preencher os dados bancários. Estas informações serão utilizadas em eventual
      necessidade de devolução de valores, o que será feito com maior brevidade.
      <div class="d-flex justify-content-between mt-5">
        <b-button class="modal-btn-voltar" @click="callbackModalDL(false)">Voltar ao Painel</b-button>
        <b-button class="modal-btn-prosseguir" @click="callbackModalDL(true)">Prosseguir</b-button>
      </div>
    </b-modal>
    <div>
      <div class="text-center" v-if="loading" style="
          background: rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%;
          width: 100%;
          height: 100%;
          position: absolute;
          display: block;
          z-index: 10002;
          margin: 0;
          top: 0;
          padding-top: 20%;
        ">
        <b-spinner variant="primary" style="width: 3rem; height: 3rem" label="Text Centered"></b-spinner>
        <br />
        <span style="color: #004e86">Processando Aguarde...</span>
      </div>
    </div>
    <Header :home="false" :arealogada="true" />

    <div id="painel" class="container-fluid painel-usuario">
      <b-row>
        <b-col cols="12" md="4" lg="3" v-if="show" style="padding: 0;" class="espaco-menu">
          <Menu class="d-none d-xl-block" />
        </b-col>
        <b-col cols="12" md="8" lg="9" class="flex" style="padding: 0;">
          <b-container fluid id="painelcontainerfluid">
            <!-- <div class="d-lg-none">
              <button class="mt-4" v-on:click="show = !show">
                <font-awesome-icon size="1x" icon="bars" />
              </button>
            </div> -->

            <!-- <h4 class="text-primary mt-5 ml-4">Meus dados</h4> -->
            <!-- <hr class="ml-4 mr-4"/> -->

            <b-alert :show="mensagem_enviada" variant="success" class="text-center">
              Atualização realizada com sucesso
            </b-alert>

            <div>
              <b-tabs content-class="mt-3">
                <b-tab title="Dados pessoais" :active="dadosPAtiva">
                  <template #title v-if="!mobile">
                    Dados pessoais
                  </template>
                  <template #title v-else>
                    <font-awesome-icon icon="user" />
                    Pessoais
                  </template>
                  <b-form name="frmMeusDados" id="frmMeusDados">
                    <b-alert :show="dismissCountDownSuc" dismissible variant="success"
                      @dismissed="dismissCountDownSuc = 0" @dismiss-count-down="countDownChanged">
                      Cadastrado com sucesso!
                    </b-alert>
                    <b-card border-variant="primary" header-text-variant="primary">
                      <div class="d-flex justify-content-end">
                        <div @click="disabled = false">
                          <b-link class="link-editar" @click="isShowing ^= true" v-show="!isShowing">
                            Editar
                            <font-awesome-icon :icon="['fa', 'pen']" class="navcontroler-times" />
                          </b-link>
                        </div>
                        <span v-show="isShowing" class="form-editando">Editando...</span>
                      </div>
                      <br>
                      <div class="d-flex justify-content-end">
                        <b-link class="link-deletar" @click="exibirModalDeletar">
                          Deletar usuário
                          <font-awesome-icon :icon="['trash']" />
                        </b-link>
                        <b-modal v-model="exibindoModalDeletar" title="Confirma exclusão" :no-close-on-backdrop="true"
                          :no-close-on-esc="true" :hide-footer="true">
                          <p>Tem certeza de que deseja deletar o usuário? Esta ação é irreversível.</p>
                          <hr>
                          <b-button @click="deletarUsuario" class="btn btn-success">Confirmar</b-button>
                          <b-button @click="fecharModalDeletar" class="pull-right btn btn-danger">Cancelar</b-button>
                        </b-modal>
                      </div>
                      <b-card-text>
                        <b-row>
                          <b-col cols="12" md="4" lg="6">
                            <label for="nome">Nome</label>
                            <b-input v-model="usuario.nome" maxlength="100" placeholder="Nome completo"
                              :state="validation_nome" id="nome" :disabled="disabled == 1 ? true : false" trim required>
                            </b-input>
                            <b-form-invalid-feedback :state="validation_nome">Informe o nome completo.
                            </b-form-invalid-feedback>
                            <b-form-valid-feedback :state="validation_nome">Campo verificado.</b-form-valid-feedback>
                          </b-col>

                          <b-col cols="12" md="4" lg="6">
                            <b-form-group label="Email" label-for="email">
                              <b-input-group>
                                <b-input id="email" type="email" v-model="usuario.email"
                                  :disabled="disabled == 1 ? true : false" :state="validation_email"
                                  placeholder="Email válido" maxlength="100" trim required></b-input>
                                <b-input-group-append v-if="usuario.ic_email_validado != 1" class="is-invalid"
                                  v-b-tooltip.hover title="Verifique seu e-mail!">
                                  <b-button variant="primary" type="button" @click="sendMail()">
                                    <b-icon icon="envelope-fill"></b-icon>
                                  </b-button>
                                </b-input-group-append>
                                <b-input-group-append v-else class="is-valid" v-b-tooltip.hover title="E-mail verificado!"
                                  is-text>
                                  <b-icon icon="envelope-fill"></b-icon>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                            <b-form-invalid-feedback :state="validation_email">Email inválido.</b-form-invalid-feedback>
                            <b-form-valid-feedback :state="validation_email">Campo verificado.</b-form-valid-feedback>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col cols="12" md="4" lg="4">
                            <label for="documento">CPF/CNPJ</label>
                            <b-input v-model="usuario.cpf_cnpj" :disabled="true" trim placeholder="Documento"
                              maxlength="18" id="documento" :state="validation_documento" @keyup="documento"
                              @blur="validarDocumento" required></b-input>
                            <b-form-invalid-feedback :state="validation_documento">Documento inválido.
                            </b-form-invalid-feedback>
                            <b-form-valid-feedback :state="validation_documento">Campo verificado.</b-form-valid-feedback>
                          </b-col>
                          <b-col cols="12" md="4" lg="4">
                            <label for="telefone">Telefone <sub>(opcional)</sub></label>
                            <the-mask :mask="['(##) ####-####', '(##) #####-####']" id="telefone"
                              v-model="usuario.telefone" class="form-control" placeholder="(XX) XXXXX-XXXX"
                              :disabled="disabled == 1 ? true : false" />
                            <b-form-invalid-feedback>Telefone inválido.
                            </b-form-invalid-feedback>
                            <b-form-valid-feedback>Campo
                              verificado.</b-form-valid-feedback>
                          </b-col>
                          <b-col cols="12" md="4" lg="4">
                            <label for="celular">Celular</label>
                            <the-mask :mask="['(##) ####-####', '(##) #####-####']" id="celular" v-model="usuario.celular"
                              class="form-control" placeholder="(XX) XXXXX-XXXX"
                              :disabled="disabled == 1 ? true : false" />
                            <b-form-invalid-feedback>Celular inválido.
                            </b-form-invalid-feedback>
                            <b-form-valid-feedback>Campo
                              verificado.</b-form-valid-feedback>
                          </b-col>
                        </b-row>



                        <b-row>
                          <b-col cols="12" md="12" lg="12">
                            <h4 class="text-primary mt-5">Endereço</h4>
                            <hr />
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col cols="12" md="2" lg="2">
                            <label for="cep">CEP</label>
                            <b-input v-model="usuario.cep" :disabled="disabled == 1 ? true : false" trim maxlength="9"
                              type="text" placeholder="_____-___" :state="validation_cep" id="cep" @keyup="cep"
                              required></b-input>
                            <b-form-invalid-feedback :state="validation_cep">CEP inválido.</b-form-invalid-feedback>
                            <b-form-valid-feedback :state="validation_cep">Campo verificado.</b-form-valid-feedback>
                          </b-col>

                          <b-col cols="12" md="6" lg="6">
                            <label for="rua">Endereço</label>
                            <b-input v-model="usuario.rua" :disabled="disabled == 1 ? true : false" trim maxlength="100"
                              type="text" placeholder="Endereço válido" :state="validation_endereco" id="rua" required>
                            </b-input>
                            <b-form-invalid-feedback :state="validation_endereco">Endereço inválido.
                            </b-form-invalid-feedback>
                            <b-form-valid-feedback :state="validation_endereco">Campo verificado.</b-form-valid-feedback>
                          </b-col>

                          <b-col cols="12" md="1" lg="2">
                            <label for="numero">Nº</label>
                            <b-input v-model="usuario.numero" :disabled="disabled == 1 ? true : false" trim
                              maxlength="100" type="text" placeholder="0" :state="validation_numero" id="numero"
                              required></b-input>
                            <b-form-invalid-feedback :state="validation_numero">Número inválido.
                            </b-form-invalid-feedback>
                            <b-form-valid-feedback :state="validation_numero">Campo verificado.</b-form-valid-feedback>
                          </b-col>

                          <b-col cols="12" md="1" lg="2">
                            <label for="complemento">Complemento</label>
                            <b-input v-model="usuario.complemento" :disabled="disabled == 1 ? true : false" trim
                              maxlength="100" type="text" placeholder="Complemento" id="complemento" required></b-input>
                            <b-form-invalid-feedback>Complemento.</b-form-invalid-feedback>
                            <b-form-valid-feedback>Campo verificado.</b-form-valid-feedback>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col cols="12" md="4" lg="4">
                            <label for="cidade">Cidade</label>
                            <b-input v-model="usuario.cidade" :disabled="disabled == 1 ? true : false" trim
                              maxlength="100" type="text" placeholder="0" :state="validation_cidade" id="cidade"
                              required></b-input>
                            <b-form-invalid-feedback :state="validation_cidade">Informe a Cidade.
                            </b-form-invalid-feedback>
                            <b-form-valid-feedback :state="validation_cidade">Campo verificado.</b-form-valid-feedback>
                          </b-col>

                          <b-col cols="12" md="4" lg="4">
                            <label for="uf">Estado</label>
                            <select id="uf" class="form-control" :class="(validation_uf ? 'is-valid' : 'is-invalid')"
                              v-model="usuario.uf" :state="validation_uf" :disabled="disabled == 1 ? true : false"
                              required>
                              <option v-for="UF in estados" :value="UF.Sigla" :key="UF.ID">
                                {{ UF.Nome }}
                              </option>
                            </select>
                            <b-form-invalid-feedback :state="validation_uf">Informe o estado.</b-form-invalid-feedback>
                            <b-form-valid-feedback :state="validation_uf">Campo verificado.</b-form-valid-feedback>
                          </b-col>

                          <b-col cols="12" md="4" lg="4">
                            <label for="bairro">Bairro</label>
                            <b-input v-model="usuario.bairro" :disabled="disabled == 1 ? true : false" trim
                              maxlength="100" type="text" placeholder="0" :state="validation_bairro" id="bairro"
                              required></b-input>
                            <b-form-invalid-feedback :state="validation_bairro">Informe o Bairro.
                            </b-form-invalid-feedback>
                            <b-form-valid-feedback :state="validation_bairro">Campo verificado.</b-form-valid-feedback>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" md="12" lg="12">
                            <h4 class="text-primary mt-5">Notificações</h4>
                            <hr />
                            <b-row>
                              <b-col>
                                <b-form-group>
                                  <b-form-checkbox-group id="infoTitulo" v-model="usuario.infoTitulo"
                                    :options="usuario.infoTitulos" name="infoTitulo" :checked="usuario.infoTitulo.indexOf(
                                      usuario.infoTitulos.value
                                    ) >= 0
                                      "></b-form-checkbox-group>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                        <b-row v-if="loginComCertificado">
                          <b-col cols="12" md="12" lg="12">
                            <h4 class="text-primary mt-5">
                              Permissões com certificado digital
                            </h4>
                            <hr />
                            <b-row>
                              <b-col>
                                <b-form-group>
                                  <b-form-checkbox-group id="permCert" v-model="usuario.permCert"
                                    :options="usuario.permCerts" name="infoTitulo" :checked="usuario.permCert.indexOf(
                                      usuario.permCerts.value
                                    ) >= 0
                                      "></b-form-checkbox-group>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                        <b-row v-if="!disabled" class="mt-4">
                          <b-col cols="12" md="12" lg="12">
                            <b-button variant="primary" @click="editar_senha = !editar_senha">Editar Senha</b-button>
                          </b-col>
                        </b-row>

                        <b-row v-if="!disabled && editar_senha">
                          <b-col cols="12" md="12" lg="12">
                            <h4 class="text-primary mt-5">Senha de acesso</h4>
                            <small>(preencher apenas se desejar trocar)</small>
                            <hr />
                          </b-col>

                          <b-col cols="12" md="4" lg="4">
                            <label for="cep">Atual</label>
                            <b-input v-model="usuario.senha_atual" type="password" id="senha_atual" required></b-input>
                          </b-col>
                          <b-col cols="12" md="4" lg="4">
                            <label for="cep">Nova senha</label>
                            <b-input v-model="usuario.senha_nova" id="senha_nova" :state="validation_senha"
                              type="password" @blur.native="validaPass" required></b-input>
                            <b-form-invalid-feedback :state="validation_senha">Os campos de senha atual, nova senha e
                              confirmação devem ser
                              preenchidos.</b-form-invalid-feedback>
                            <b-form-valid-feedback :state="validation_senha">Campo verificado.</b-form-valid-feedback>
                            <transition name="fade">
                              <b-alert :show="alertPassBasic" fade variant="danger" class="text-center">
                                A senha deve conter ao menos 8 caracteres,
                                <br />uma maiúscula, uma minúscula, <br />um
                                caracter especial e um número.
                              </b-alert>
                            </transition>
                            <transition name="fade">
                              <b-alert :show="alert" fade variant="danger" class="text-center"
                                v-html="alertMessage"></b-alert>
                            </transition>
                          </b-col>
                          <b-col cols="12" md="4" lg="4">
                            <label for="cep">Confirmação</label>
                            <b-input v-model="usuario.senha_nova_confirmacao" id="senha_nova_confirmacao"
                              :state="validation_senha" type="password" required></b-input>
                          </b-col>
                        </b-row>
                        <div class="float-right">
                          <div @click="disabled = false">
                            <b-button variant="primary" size="lg" class="mt-5 btn-editar" type="button"
                              @click="isShowing ^= true" v-show="!isShowing">
                              Editar
                              <font-awesome-icon :icon="['fa', 'pen']" class="navcontroler-times" />
                            </b-button>
                          </div>
                          <b-button variant="success" size="lg" class="mt-5" type="button" @click="continuar"
                            v-show="isShowing">Salvar</b-button>
                        </div>
                      </b-card-text>
                    </b-card>
                  </b-form>
                </b-tab>
                <b-tab title="Dados Bancários Recebimento" :active="liqAtiva">
                  <template #title v-if="!mobile">
                    Dados Bancários Recebimento
                  </template>
                  <template #title v-else>
                    <font-awesome-icon icon="hand-holding-usd" />
                    Bancários
                  </template>
                  <b-form name="frmLiquidacaoDados" id="frmLiquidacaoDados">
                    <b-alert :show="mensagem_enviada_dl" variant="success" class="text-center">Atualização realizada com
                      sucesso</b-alert>
                    <b-card border-variant="primary" header-text-variant="primary">
                      <div class="d-flex justify-content-end">
                        <div @click="disabledDL = false">
                          <b-link class="link-editar" @click="isShowingDL ^= true" v-show="!isShowingDL">
                            Editar
                            <font-awesome-icon :icon="['fa', 'pen']" class="navcontroler-times" />
                          </b-link>
                        </div>
                        <span v-show="isShowingDL" class="form-editando">Editando...</span>
                      </div>
                      <b-card-text>
                        <b-row>
                          <b-col cols="12" md="6" lg="6">
                            <label for="conta_nome">Nome do Favorecido</label>
                            <b-input v-model="conta.nome" :disabled="disabledDL == 1 ? true : false" trim maxlength="100"
                              type="text" placeholder="" :state="validation_conta_nome" :formatter="apenasLetrasENumeros"
                              id="conta_nome" required></b-input>
                            <!-- :formatter="apenasLetras" -->
                            <b-form-invalid-feedback :state="validation_conta_nome">Informe o nome do
                              Favorecido.</b-form-invalid-feedback>
                            <b-form-valid-feedback :state="validation_conta_nome">Campo
                              verificado.</b-form-valid-feedback>
                          </b-col>
                          <b-col cols="12" md="6" lg="6">
                            <label for="conta_documento">CPF / CNPJ do Favorecido</label>
                            <b-input v-model="conta.documento" :disabled="disabledDL == 1 ? true : false" trim type="text"
                              placeholder="Documento" maxlength="18" id="conta_documento"
                              :state="validation_conta_documento" @keyup="documento" @blur="validarDocumento" required>
                            </b-input>
                            <b-form-invalid-feedback :state="validation_conta_documento">Documento do Favorecido.
                            </b-form-invalid-feedback>
                            <b-form-valid-feedback :state="validation_conta_documento">Campo verificado.
                            </b-form-valid-feedback>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" md="3" lg="3">
                            <b-form-group label="Tipo de Conta">
                              <b-form-radio-group id="conta_tipo" v-model="conta.tipo" :options="options.conta_tipo"
                                name="conta_tipo" :state="validation_conta_tipo"
                                :disabled="disabledDL == 1 ? true : false" required></b-form-radio-group>
                            </b-form-group>
                            <b-form-invalid-feedback :state="validation_conta_tipo">Tipo de
                              Conta.</b-form-invalid-feedback>
                            <b-form-valid-feedback :state="validation_conta_tipo">Campo
                              verificado.</b-form-valid-feedback>
                            <!--
                                <b-input v-model="conta.tipo" :disabled="disabledDL == 1 ? true : false" trim maxlength="1" type="text" placeholder="" :state="validation_conta_tipo" id="conta_tipo" required ></b-input>
                                <b-form-invalid-feedback :state="validation_conta_tipo">Tipo de Conta.</b-form-invalid-feedback>
                                <b-form-valid-feedback :state="validation_conta_tipo">Campo verificado.</b-form-valid-feedback>
                              -->
                          </b-col>
                          <b-col cols="12" md="9" lg="9">
                            <label for="conta_banco">Banco</label>
                            <v-select v-if="!isDisabled" id="conta_banco" v-model="conta.banco_cd"
                              :reduce="bancos => bancos.code"
                              :class="(validation_conta_banco ? 'is-valid' : 'is-invalid')" :disabled="isDisabled"
                              :options="bancos" :state="validation_conta_banco" :value="'code'"></v-select>
                            <b-input v-else :placeholder="bancoConcatenado" :disabled="isDisabled"></b-input>

                            <b-form-invalid-feedback :state="validation_conta_banco">Informe o Banco.
                            </b-form-invalid-feedback>
                            <b-form-valid-feedback :state="validation_conta_banco">Campo verificado.
                            </b-form-valid-feedback>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" md="4" lg="4">
                            <label for="conta_agencia">Agência</label>
                            <the-mask id="conta_agencia" class="form-control" mask="#####" v-model="conta.agencia"
                              :disabled="disabledDL == 1 ? true : false" :state="validation_conta_agencia"
                              :class="(validation_conta_agencia ? 'is-valid' : 'is-invalid')" placeholder="" trim
                              required></the-mask>
                            <b-form-invalid-feedback :state="validation_conta_agencia">Agência.
                            </b-form-invalid-feedback>
                            <b-form-valid-feedback :state="validation_conta_agencia">Campo verificado.
                            </b-form-valid-feedback>
                          </b-col>
                          <b-col cols="12" md="2" lg="2">
                            <label for="conta_agencia_dg">Dígito Agência</label>
                            <b-input v-model="conta.agencia_dg" :disabled="disabledDL == 1 ? true : false" trim
                              maxlength="1" type="text" placeholder="" id="conta_agencia_dg"></b-input>
                            <!-- :state="validation_conta_agencia_dg"
                                    <b-form-invalid-feedback :state="validation_conta_agencia_dg">Informe o Dígito da Agência (caso exista).</b-form-invalid-feedback>
                                    <b-form-valid-feedback :state="validation_conta_agencia_dg">Campo verificado.</b-form-valid-feedback>
                                     -->
                          </b-col>
                          <b-col cols="12" md="4" lg="4">
                            <label for="conta_conta">Conta</label>
                            <the-mask id="conta_conta" class="form-control" mask="##########" v-model="conta.conta"
                              :disabled="disabledDL == 1 ? true : false" :state="validation_conta_conta"
                              :class="(validation_conta_conta ? 'is-valid' : 'is-invalid')" placeholder="" trim
                              required></the-mask>
                            <b-form-invalid-feedback :state="validation_conta_conta">Informe a Conta.
                            </b-form-invalid-feedback>
                            <b-form-valid-feedback :state="validation_conta_conta">Campo verificado.
                            </b-form-valid-feedback>
                          </b-col>
                          <b-col cols="12" md="2" lg="2">
                            <label for="conta_conta_dg">Conta dígito</label>
                            <b-input v-model="conta.conta_dg" :disabled="disabledDL == 1 ? true : false" trim
                              maxlength="1" type="text" placeholder="" :state="validation_conta_conta_dg"
                              id="conta_conta_dg"></b-input>
                            <b-form-invalid-feedback :state="validation_conta_conta_dg">Informe o dígito da Conta.
                            </b-form-invalid-feedback>
                            <b-form-valid-feedback :state="validation_conta_conta_dg">Campo verificado.
                            </b-form-valid-feedback>
                          </b-col>
                        </b-row>

                        <div class="float-right">
                          <div @click="disabledDL = false">
                            <b-button variant="primary" size="lg" class="mt-5 btn-editar" type="button"
                              @click="isShowingDL ^= true" v-show="!isShowingDL">
                              Editar
                              <font-awesome-icon :icon="['fa', 'pen']" class="navcontroler-times" />
                            </b-button>
                          </div>
                          <b-button variant="success" size="lg" class="mt-5" type="button" @click="continuarDL"
                            v-show="isShowingDL">Salvar</b-button>
                        </div>
                      </b-card-text>
                      <!--<b-button variant="success" size="lg" class="mt-5" type="button" @click="resgataDL">Termo de Aceite</b-button>-->
                    </b-card>
                  </b-form>
                </b-tab>
              </b-tabs>
            </div>
          </b-container>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Header from "../components/Header";
import API from "../services/api";
import Menu from "../template/Menu";
import Estados from "../services/estados";
import EstadoCivil from "../services/estado_civil";
import { TheMask } from "vue-the-mask";
import api from "../services/api";

export default {
  components: {
    Header,
    Menu,
    TheMask,
  },
  data() {
    return {
      mobile: window.innerWidth < 1200,
      editar_senha: false,
      pendenteDL: false,
      isCnpj: "",
      dadosPAtiva: true,
      liqAtiva: false,
      alert: false,
      alertMessage: "",
      alertPassBasic: false,
      countDownChanged: 0,
      isShowing: false,
      isShowingDL: false,
      disabled: true,
      disabledDL: true,
      mensagem_enviada: false,
      mensagem_enviada_dl: false,
      dismissSecs: 5,
      dismissCountDown: 0,
      dismissCountDownDOC: 0,
      dismissCountDownSuc: 0,
      arquivosCertidao: [],
      loading: false,
      show: true,
      message: "",
      options: [],
      erro: false,
      estados: [],
      bancos: [],
      modalShow: false,
      loginComCertificado: false,
      estado_civil: "",
      exibindoModalDeletar: false,
      usuario: {
        id: "",
        nome: "",
        email: "",
        cpf_cnpj: "",
        rua: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        codibge: 0,
        uf: "",
        cep: "",
        telefone: "",
        celular: "",
        rg: "",
        rg_org: "",
        profissao: "",
        estadoCivil: "",
        ic_email_validado: "",
        nm_email_atual: "",
        infoTitulo: [],
        infoTitulos: [
          { value: 0, text: "Aceito receber informações por Email" },
          { value: 1, text: "Aceito receber informações por WhatsApp" },
        ],
        permCert: [],
        permCerts: [
          {
            value: "ic_pesquisa_titulo",
            text: "Pesquisa de titulo sem certificado",
          },
        ],
        rg_uf: "",
        senha_atual: "",
        senha_nova: "",
        senha_nova_confirmacao: "",
      },
      conta: {
        nome: "",
        documento: "",
        tipo: "",
        banco_cd: "",
        banco: {},
        agencia: "",
        //agencia_dg: '',
        conta: "",
        conta_dg: "",
      },
      options: {
        conta_tipo: [
          { text: 'Corrente', value: 'C' },
          { text: 'Poupança', value: 'P' },
        ]
      }
    };
  },
  computed: {
    cpf_cnpjc() {
      return this.usuario.cpf_cnpj;
    },
    validation_nome() {
      if (this.usuario.nome != undefined) {
        var out_nome = this.usuario.nome;
        var nomeLimpo = out_nome.trim();
        return nomeLimpo.length > 3;
      } else return false;
    },
    validation_numero_telefone(){
      if(this.usuario.telefone != undefined) {
        var out_telefone = this.usuario.telefone;
        var telefoneLimpo = out_telefone.replace(/\D/g, '');
        var telefoneFormatado = this.validarNumeroTelefone(telefoneLimpo);
        this.usuario.telefone = telefoneFormatado
        return telefoneLimpo.length == 11 || telefoneLimpo.length == 10;
      } else {
         return false;
      }
    },
    validation_numero_celular() {
      if(this.usuario.celular != undefined) {
        var out_celular = this.usuario.celular;
        var celularLimpo = out_celular.replace(/\D/g, '');
        var celularFormatado = this.validarNumeroCelular(celularLimpo)
        this.usuario.celular = celularFormatado
        return celularLimpo.length == 11;
      } else {
         return false;
      }
    },
    validation_bairro() {
      if (this.usuario.bairro != undefined) {
        var out_nome = this.usuario.bairro;
        var nomeLimpo = out_nome.trim();
        return nomeLimpo.length > 0;
      } else return false;
    },
    validation_cidade() {
      if (this.usuario.cidade != undefined) {
        var out_nome = this.usuario.cidade;
        var nomeLimpo = out_nome.trim();
        return nomeLimpo.length > 0;
      } else return false;
    },
    validation_uf() {
      if (this.usuario.uf != undefined) {
        var out_nome = this.usuario.uf;
        var nomeLimpo = out_nome.trim();
        return nomeLimpo.length > 0;
      } else return false;
    },
    validation_numero() {
      if (this.usuario.numero != undefined) {
        var out_nome = this.usuario.numero;
        var nomeLimpo = out_nome.trim();
        return nomeLimpo.length > 0;
      } else return false;
    },
    validation_documento() {
      if (!this.usuario.cpf_cnpj) {
        return false;
      }
      // validation_numero_celular()
      // validation_numero_telefone()

      if (this.usuario.cpf_cnpj != undefined)
        return this.usuario.cpf_cnpj.length > 0 && this.usuario.cpf_cnpj != "";
      else return false;
    },
    validation_email() {
      if (this.usuario.email != undefined) {
        /* eslint-disable */
        var er =
          /^[a-zA-Z0-9][a-zA-Z0-9\._-]+@([a-zA-Z0-9\._-]+\.)[a-zA-Z-0-9]{2,3}/;
        if (!er.exec(this.usuario.email)) return false;
        else return this.usuario.email.length > 0 && this.usuario.email != "";
      } else return false;
    },
    validation_cep() {
      if (this.usuario.cep != undefined) {
        var dados = this.usuario.cep;
        var dadosLimpo = dados.trim();
        return dadosLimpo.length > 7;
      } else return false;
    },
    validation_endereco() {
      if (this.usuario.rua != undefined) {
        var out_nome = this.usuario.rua;
        var nomeLimpo = out_nome.trim();
        return nomeLimpo.length > 0;
      } else return false;
    },
    validation_dt_vigencia_final() {
      if (this.usuario.dt_vigencia_final != undefined) {
        var out_nome = this.usuario.dt_vigencia_final;
        var nomeLimpo = out_nome.trim();
        return nomeLimpo.length > 0;
      } else return false;
    },

    validation_senha() {
      if (
        this.usuario.senha_atual.length > 0 &&
        this.usuario.senha_nova.length > 0 &&
        this.usuario.senha_nova == this.usuario.senha_nova_confirmacao
      ) {
        return true;
      } else return false;
    },
    validation_conta_nome() {
      if (this.conta.nome != undefined) {
        var out_nome = this.conta.nome;
        var nomeLimpo = out_nome.trim();
        return nomeLimpo.length > 0;
      } else return false;
    },
    validation_conta_documento() {
      if (this.conta.documento != undefined) {
        var out_nome = this.conta.documento;
        var nomeLimpo = out_nome.trim();
        return nomeLimpo.length > 0;
      } else return false;
    },
    validation_conta_tipo() {
      if (this.conta.tipo != undefined) {
        var out_nome = this.conta.tipo;
        var nomeLimpo = out_nome.trim();
        return nomeLimpo.length > 0;
      } else return false;
    },
    validation_conta_banco() {
      return (this.conta.banco_cd != undefined && this.conta.banco_cd != '');
    },
    validation_conta_agencia() {
      if (this.conta.agencia != undefined) {
        var out_nome = this.conta.agencia;
        var nomeLimpo = out_nome.trim();
        return nomeLimpo.length > 0;
      } else return false;
    },
    /*validation_conta_agencia_dg(){
      if (this.conta.agencia_dg != undefined) {
        var out_nome = this.conta.agencia_dg;
        var nomeLimpo = out_nome.trim();
        return nomeLimpo.length > 0;
      } else return false;
    },*/
    validation_conta_conta() {
      if (this.conta.conta != undefined) {
        var out_nome = this.conta.conta;
        var nomeLimpo = out_nome.trim();
        return nomeLimpo.length > 0;
      } else return false;
    },
    validation_conta_conta_dg() {
      return true;
      // Removido obrigatoriedade do campo
      // if (this.conta.conta_dg != undefined) {
      //   var out_nome = this.conta.conta_dg;
      //   var nomeLimpo = out_nome.trim();
      //   return nomeLimpo.length > 0;
      // } else return false;
    },
    isDisabled() {
      return this.disabledDL === true;
    },
    bancoConcatenado() {
      if (this.conta.banco_cd) {
        const banco = this.bancos.find(item => item.code == this.conta.banco_cd);
        if (banco) {
          return `${banco.label}`;
        }
      }
      return ''; // Retorna uma string vazia se nenhum código estiver selecionado
    },
  },
  filters: {
    dataHora: function (value) {
      if (value !== "" && value !== undefined && value !== null) {
        let date = new Date(value);
        return date.toLocaleDateString("pt-BR", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          year: "numeric",
          month: "numeric",
          day: "numeric",
        });
      }
      return "";
    },
    Celular: function (value) {
      var d = value;
      d = d.replace(/\D/g, "");
      d = d.replace(/^(\d\d)(\d)/g, "($1) $2");
      d = d.replace(/(\d{5})(\d)/, "$1-$2");
      return d;
    },
    Telefone: function (value) {
      var d = value;
      d = d.replace(/\D/g, "");
      d = d.replace(/^(\d\d)(\d)/g, "($1) $2");
      d = d.replace(/(\d{4})(\d)/, "$1-$2");
      return d;
    },
    Moeda: function (v) {
      /*var p = v.indexOf(".");
            v = v.slice(0, (p+3))
            v = v.replace(/\D/g,'');
            v = (v/100).toFixed(2) + '';
            */
      v = v.toString().replace(".", ",");
      v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,");
      v = v.replace(/(\d)(\d{3}),/g, "$1.$2,");
      return "R$ " + v;
    },
  },
  created: function () {
    let validaContaBancaria
    if (this.$route.params.dadosLiq != null) {
      this.dadosPAtiva = false;
      this.liqAtiva = true;
    }

    this.getDados();
    this.getDadosLiquidacao().then(() => {
      validaContaBancaria = this.conta.agencia && this.conta.conta && this.conta.banco_cd && this.conta.documento && this.conta.nome && this.conta.tipo
      this.pendenteDL = !validaContaBancaria;
      if (!this.$route.params.dadosBancarios && !validaContaBancaria) {

        setTimeout(() => {
          // this.$refs["confirmaSemDadosBancarios"].show();
        }, 1)
      }
    })




    this.logged = true;
    if (
      localStorage.getItem("sg_tipo_documento") &&
      localStorage.getItem("SSL_CLIENT_S_DN_CN") &&
      localStorage.getItem("nm_tipo_certificado") &&
      localStorage.getItem("SSL_CLIENT_S_DN") &&
      localStorage.getItem("SSL_CLIENT_V_START") &&
      localStorage.getItem("SSL_CLIENT_V_END")
    )
      this.loginComCertificado = true;
  },
  methods: {
    exibirModalDeletar() {
      this.exibindoModalDeletar = true;
    },
    fecharModalDeletar() {
      this.exibindoModalDeletar = false;
    },
    deletarUsuario(response) {
      const token = localStorage.getItem("jwtToken");
      const userId = this.$data.usuario.id;
      API.post(`usuario/deletar?token=${token}&id=${userId}`, this.$data.usuario).then((res) => {
        if (res.status == 200) {
          localStorage.removeItem("jwtToken");
          location.reload();
        }
      }).catch((error) => {
        console.log('error')
      })
    },
    callbackModalDL(response) {
      if (response) {
        this.dadosPAtiva = false;
        this.liqAtiva = true;
        this.isShowingDL = true;
        this.disabledDL = false;
        this.$refs["confirmaSemDadosBancarios"].hide();
      }
      else this.$router.push({ name: 'painel' });
    },
    apenasLetras: function (value) {
      return value.replace(/[^a-z-A-Z-& ]/g, "");
    },
    apenasLetrasENumeros: function (value) {
      return value.replace(/[^a-z-A-Z-0-9-& ]/g, "");
    },
    continuar() {
      if (this.validar()) {
        return this.finalizar();
      }
    },
    continuarDL() {
      if (this.validarDL()) {
        return this.finalizarDL();
      }
    },
    valid() {
      if (this.validarDocumento() == false) {
        return this.finalizar();
      }
    },
    validarCPF(cpf) {
      var validar = "false";
      cpf = cpf.replace(/[^\d]+/g, "");
      if (cpf == "") {
        validar = "true";
      }
      // Elimina CPFs invalidos conhecidos
      else if (
        cpf.length != 11 ||
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999"
      )
        validar = "true";

      var add = 0;
      var i;
      var rev;
      for (i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
      rev = 11 - (add % 11);
      if (rev == 10 || rev == 11) rev = 0;
      if (rev != parseInt(cpf.charAt(9))) validar = "true";

      // Valida 2o digito
      add = 0;
      for (i = 0; i < 10; i++)
        add += parseInt(cpf.charAt(i)) * (11 - i);

      rev = 11 - (add % 11);

      if (rev == 10 || rev == 11)
        rev = 0;

      if (rev != parseInt(cpf.charAt(10)))
        validar = "true";

      if (validar == "true") {
        this.$set(this.usuario, "documento", "");
        this.dismissCountDownDOC = this.dismissSecs;
        return false;
      } else {
        return true;
      }
    },
    VerificaCNPJ(V_CNPJ) {
      var CNPJ1;
      var CNPJ;
      var i, y, x;
      CNPJ1 = V_CNPJ;
      CNPJ = CNPJ1.trim();

      if (!(CNPJ.length == 18 || CNPJ.length == 14)) {
        //return false;
        this.$set(this.usuario, "documento", "");
        this.dismissCountDownDOC = this.dismissSecs;
      } else {
        //substituir os caracteres que nao sao numeros
        CNPJ = CNPJ.replace(/[.,\/-]/g, ""); //tanks eclesiastes ;)
        var nonNumbers = /\D/;
        if (nonNumbers.test(CNPJ)) {
          // return false;
          this.$set(this.usuario, "documento", "");
          this.dismissCountDownDOC = this.dismissSecs;
        }
        var a = [];
        var b = new Number();
        var c = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        for (i = 0; i < 12; i++) {
          a[i] = CNPJ.charAt(i);
          b += a[i] * c[i + 1];
        }
        if ((x = b % 11) < 2) {
          a[12] = 0;
        } else {
          a[12] = 11 - x;
        }
        b = 0;
        for (y = 0; y < 13; y++) {
          b += a[y] * c[y];
        }
      }
      if ((x = b % 11) < 2) {
        a[13] = 0;
      } else {
        a[13] = 11 - x;
      }
      if (CNPJ.charAt(12) != a[12] || CNPJ.charAt(13) != a[13]) {
        //return false;
        this.$set(this.usuario, "documento", "");
        this.dismissCountDownDOC = this.dismissSecs;
      }
      return true;
    },
    finalizar() {
      const token = localStorage.getItem("jwtToken");
      API.put(`usuario?token=${token}`, this.$data.usuario).then((res) => {
        // console.log(res.data)
        if (res.data.enviada == 1) {
          this.mensagem_enviada = true;
          this.isShowing = false;
          this.disabled = true;
          if (this.pendenteDL) {
            this.$refs["confirmaSemDadosBancarios"].show();
          }
          return true;
          // return (this.isShowing = false);
        } else if (res.data.enviada == 2) {
          this.alert = true;
          this.alertMessage =
            "A senha original não coincide, <br/> por favor, verifique e tente novamente. <br/><i>(os demais dados foram atualziados)</i>";
        } else {
          this.alert = true;
          this.alertMessage =
            "Erro no processamento, por favor tente novamente";
        }
      });
    },
    finalizarDL() {
      const token = localStorage.getItem("jwtToken");
      let banco_cd = this.$data.conta.banco_cd
      let banco = this.bancos.find(item => item.code == banco_cd);
      // console.log(banco)
      if (banco) {
        this.$data.conta.banco = { code: banco.code, label: banco.label };
      }
      API.post(
        `usuario/dadosbancarios/store?token=${token}`,
        this.$data.conta
      ).then((res) => {
        // console.log(res.data)
        if (res.data.status == "success") {
          this.mensagem_enviada_dl = true;
          this.isShowingDL = false;
          return (this.disabledDL = true);
          // return (this.isShowingDL = false);
        } else {
          this.alert = true;
          this.alertMessage =
            "Erro no processamento, por favor tente novamente";
        }
      });
    },
    resgataDL() {
      const token = localStorage.getItem("jwtToken");
      API.get(`usuario/termoaceite/resgata/1?token=${token}`);
    },
    validar: function () {
      //validar o formulario
      var inputs = document.getElementById("frmMeusDados").getElementsByTagName("input");
      var i;
      for (i = 0; i < inputs.length; i++) {
        if (document.getElementById("frmMeusDados").getElementsByTagName("input")[i].id != "complemento" &&
          document.getElementById("frmMeusDados").getElementsByTagName("input")[i].id != "complemento"
        ) {
          if (document.getElementById("frmMeusDados").getElementsByTagName("input")[i].value.trim() == "") {
            this.erro = true;
            this.dismissCountDown = this.dismissSecs;
          } else {
            this.erro = false;
            this.verificarCheckBox();
            return this.Verifica();
          }
        }
      }
    },
    Verifica() {
      let self = this
      let erros = 0,
        campos = ["nome", "email", "cep", "rua", "numero", "bairro", "cidade", "uf"];
      if (!(this.isInvalid("telefone", this.usuario["telefone"]) && this.isInvalid("celular", this.usuario["celular"]))) {
        campos.push("infoTitulo")
      }


      // verifica campos
      campos.forEach((campo) => {
        erros += self.isInvalid(campo, self.usuario[campo]) ? 1 : 0;
      });

      return erros > 0 ? false : true;
    },
    validarDL: function () {
      let errosDL = true;

      Object.keys(this.conta).forEach((element) => {
        let elementoAtual = this.conta[element];
        //console.log(element)
        if (errosDL) {
          if (element == "banco_cd") {
            if (elementoAtual == undefined) errosDL = false;
          } else {
            if (elementoAtual.length <= 0 && element != "agencia_dg") {
              errosDL = false;
            }
          }
        }
      });
      return errosDL;
    },
    VerificaDL() {
      let self = this,
        erros = 0,
        campos = ["nome", "documento", "tipo", "banco_cd", "agencia", "conta", "conta_dg",];

      // verifica campos
      campos.forEach((campo) => {
        erros += self.isInvalid(campo, self.conta[campo]) ? 1 : 0;
      });

      return erros > 0 ? false : true;
    },
    isInvalid(field, value) {
      if (!value) document.getElementById(field).classList.add("is-invalid");
      else document.getElementById(field).classList.remove("is-invalid");
      return value ? false : true;
    },
    async getDados() {
      const token = localStorage.getItem("jwtToken");
      const res = await API.get(`usuario/logado?token=${token}`);

      this.usuario.id = res.data[0].cd_usuario;
      this.usuario.nome = res.data[0].nm_usuario;
      this.usuario.cpf_cnpj = res.data[0].nm_nr_cpfcnpj;
      this.usuario.celular = res.data[0].nm_nr_celular;
      this.usuario.telefone = res.data[0].nm_nr_telefone;
      this.usuario.email = res.data[0].nm_email;
      this.usuario.cep = res.data[0].nm_nr_cep;
      this.usuario.rua = res.data[0].nm_endereco;
      this.usuario.complemento = res.data[0].nm_complemento;
      this.usuario.cidade = res.data[0].nm_cidade;
      this.usuario.bairro = res.data[0].nm_bairro;
      this.usuario.codibge = res.data[0].nm_ibge;
      this.usuario.uf = res.data[0].nm_uf;
      this.usuario.numero = res.data[0].nm_nr_endereco;
      this.usuario.rg = res.data[0].nm_rg;
      this.usuario.rg_org = res.data[0].nm_rg_org;
      this.usuario.rg_uf = res.data[0].nm_rg_uf;
      this.usuario.infoTitulo = res.data[0].nm_infoNotificacao;
      this.usuario.profissao = res.data[0].nm_profissao;
      this.usuario.estadoCivil = res.data[0].nm_estadoCivil;
      this.usuario.ic_email_validado = res.data[0].ic_email_validado;
      this.usuario.nm_email_atual = res.data[0].nm_email;
    },
    async getDadosLiquidacao() {
      const token = localStorage.getItem("jwtToken");
      const res = await API.get(`usuario/dadosbancarios?token=${token}`);
      const resBancos = await API.get(
        `usuario/dadosbancarios/bancos?token=${token}`
      );
      // this.bancos = resBancos.data.map((banco) => {return { value: banco.code, text: banco.label}});
      this.bancos = resBancos.data;
      if (res.data != "") {
        this.conta.nome = res.data.nm_nome;
        this.conta.documento = res.data.nm_documento;
        this.conta.tipo = res.data.cd_tipo;
        this.conta.banco.code = res.data.cd_banco;
        this.conta.banco.label = res.data.ds_banco;
        this.conta.banco_cd = res.data.cd_banco;
        this.conta.agencia = res.data.nm_agencia;
        this.conta.agencia_dg = res.data.nm_agdigito;
        this.conta.conta = res.data.nm_conta;
        this.conta.conta_dg = res.data.nm_contadigito;
      }
    },
    validaPass() {
      //let bt = document.getElementById('btn-continuar')
      const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@()$%^&*=_{}[\]:;\"'|\\<>,.\/~`±§+-]).{8,30}$/,
        str = this.usuario.senha_nova;
      let m = regex.exec(str),
        self = this;
      // console.log(str);
      if (m !== null) {
        self.alertPassBasic = false;
        //bt.disabled = false
      } else {
        self.alertPassBasic = true;
        //bt.disabled = true
      }
    },
    validarDocumento: function (event) {
      if (event.target.value.length > 14) {
        //valida cnpj
        this.VerificaCNPJ(event.target.value);
      } else {
        //valida cpf
        this.validarCPF(event.target.value);
      }
    },
    cep: function (event) {
      var d = event.target.value;
      d = d.replace(/^(\d{5})(\d)/, "$1-$2");
      event.target.value = d;
      if (d.length == 9) {
        this.BuscarCep(d, event.target.id);
      }
    },
    documento: function (event) {
      var value = event.target.value;
      if (value == null) {
        return "";
      } else {
        let v = value;
        //Remove tudo o que não é dígito
        v = v.replace(/\D/g, "");
        if (v.length < 14) {
          //CPF
          //Coloca um ponto entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          //Coloca um ponto entre o terceiro e o quarto dígitos
          //de novo (para o segundo bloco de números)
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          //Coloca um hífen entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        } else {
          //CNPJ
          //Coloca ponto entre o segundo e o terceiro dígitos
          v = v.replace(/^(\d{2})(\d)/, "$1.$2");
          //Coloca ponto entre o quinto e o sexto dígitos
          v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
          //Coloca uma barra entre o oitavo e o nono dígitos
          v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
          //Coloca um hífen depois do bloco de quatro dígitos
          v = v.replace(/(\d{4})(\d)/, "$1-$2");
        }
        event.target.value = v;
      }
    },
    verificarCheckBox() {
      var infoTitulo = document.getElementsByName("infoTitulo");

      for (var i = 0; i < infoTitulo.length; i++) {
        if (infoTitulo[i].checked == true) {
          return true;
        } else {
          return false;
        }
      }
    },
    validarNumeroTelefone(telefone){
      return telefone.replace(/\D/g, '').replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    },
    validarNumeroCelular(celular){
      return celular.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
    },
    BuscarCep: function (cep, id) {
      var cepl = cep.replace("-", "");
      var self = this;
      try {
        axios
          .get(`https://viacep.com.br/ws/${cepl}/json/`)
          .then((resp) => {
            if (resp.data.erro == true) {
              this.message = "Cep não encontrado.";
            } else {
              if (id == "cep") {
                self.$set(self.usuario, "rua", resp.data.logradouro);
                self.$set(self.usuario, "bairro", resp.data.bairro);
                self.$set(self.usuario, "cidade", resp.data.localidade);
                self.$set(self.usuario, "uf", resp.data.uf);
                self.$set(self.usuario, "complemento", resp.data.complemento);
                self.$set(self.usuario, "codibge", resp.data.ibge);
                document.getElementById("numero").focus();
              } else {
                self.$set(self.usuario, "endereco", resp.data.logradouro);
                self.$set(self.usuario, "bairro", resp.data.bairro);
                self.$set(self.usuario, "cidade", resp.data.localidade);
                self.$set(self.usuario, "uf", resp.data.uf);
                self.$set(self.usuario, "complemento", resp.data.complemento);
                self.$set(self.usuario, "codibge", resp.data.ibge);
                document.getElementById("numero").focus();
              }
            }
          })
          .catch(() => {
            console.error("error");
          });
      } catch (error) {
        console.error("error");
      } finally {
        console.error("error");
      }
    },
    async sendMail() {
      const token = localStorage.getItem("jwtToken");
      const res = await API.post(`usuario/verifica-email?token=${token}`).then(res => {
        alert(res.data.message)
      });
    }
  },
  mounted() {
    this.estados = Estados;
    this.estado_civil = EstadoCivil;
  },
  watch: {
    cpf_cnpjc(value) {
      //console.log(value)
      let removeFormatacao = value.replace(["-", ".", "/"], "");
      if (removeFormatacao.length == 14) this.isCnpj = true;
      if (removeFormatacao.length == 11) this.isCnpj = false;
    },
  },
};
</script>

<style scoped>
@keyframes pencilEditAnimation {

  0%,
  38%,
  100% {
    margin-left: 46px;
    opacity: 1;
    color: #597EB5;
  }

  4% {
    margin-left: 46px;
    opacity: 0;
    color: transparent;
  }

  4.5% {
    margin-left: -14px;
  }

  10%,
  14%,
  18.5% {
    margin-left: -14px;
    opacity: 1;
  }

  10% {
    color: transparent;
  }

  14% {
    color: #597EB5;
  }
}

@keyframes trashEditAnimation {

  0%,
  38%,
  100% {
    margin-left: 8rem;
    opacity: 1;
    color: #f70505;
  }

  4% {
    margin-left: 8rem;
    opacity: 0;
    color: transparent;
  }

  4.5% {
    margin-left: -14px;
  }

  10%,
  14%,
  18.5% {
    margin-left: -14px;
    opacity: 1;
  }

  10% {
    color: transparent;
  }

  14% {
    color: #f70505;
  }
}

#wrapper-spinner {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: calc(100% - 80px);
}

#wrapper-spinner .v-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -10px 0px 0px -20px;
}

#painel {
  position: fixed;
  width: 100%;
  left: 0px;
  bottom: 0px;
  padding-top: 0px;
  height: calc(100% - 80px);
  background-color: #ffffff;
  overflow-x: hidden;
  border-top: 1px solid #f1f1f1;
}

.lista-certidoes {
  color: #000;
}

.lista-certidoes b {
  font-size: 0.85rem;
  color: var(--main-azul);
}

a {
  color: #555;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

#loading-solicitante {
  vertical-align: 0;
  margin-left: -21px;
}

.load {
  top: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spin {
  background: #fff;
  height: 80px;
  width: 80px;
  border-radius: 50vh;
  border-color: #209cee;
  border-top: 5px solid #209cee;
  animation: loading 3s linear infinite;
}

.loading {
  position: absolute;
  color: #000;
}

@keyframes loading {
  100% {
    transform: rotate(360deg);
  }
}

.bold {
  font-weight: bold;
}

.mensagemErro {
  color: red;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active em versões anteriores a 2.1.8 */
  {
  opacity: 0;
}

.espaco-menu {
  width: calc(296px + 5px + 5px);
  flex: unset;
  margin-left: calc(3.8vw - 5px);
}

#painel>.row {
  justify-content: space-between;
}

#painel {
  scrollbar-width: none;
}

#painel::-webkit-scrollbar {
  display: none;
}

#painel h1 {
  text-align: left;
  font: normal normal bold 25px/41px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #597EB5;
  margin-bottom: 22px;
}

#painelcontainerfluid {
  padding: 0;
  padding-bottom: 52px;
  padding-right: 3.8vw;
  margin-top: 37px;
}

@media (max-width:1600px) and (min-width:1400px) {
  .espaco-menu {
    margin-left: calc(20px - 5px) !important;
  }

  #painelcontainerfluid {
    padding-right: 20px !important;
  }
}

@media (max-width:1399px) and (min-width:1200px) {
  .espaco-menu {
    margin-left: calc(10px - 5px) !important;
  }

  #painelcontainerfluid {
    padding-right: 10px !important;
  }
}

@media (max-width:1199px) {
  #painel {
    padding: 0 17px;
  }

  #painel>.row {
    width: 100%;
    /* max-width: none; */
    margin: 0 !important;
    padding: 0px !important;
    margin-bottom: 70px !important;
    /* margin-left: -17px !important; */
    max-width: 100%;
    margin-left: 0px !important;
  }

  .col-lg-9 {
    max-width: none;
    flex: 1 1 100%;
    padding: 0;
  }

  #painelcontainerfluid {
    padding: 0px !important;
  }
}

.container-fluid.painel-usuario .btn-editar {
  text-align: center;
  font: normal normal 400 20px/20px 'Kanit', sans-serif;
  letter-spacing: -1%;
  padding: 0 50px;
  display: flex;
  align-items: center;
  width: 90px;
  height: 49px;
  border-radius: 40px;
  border: none;
}

.container-fluid.painel-usuario .link-editar {
  font: normal normal 300 16px/20px 'Kanit', sans-serif;
  letter-spacing: -1%;
  padding: 0;
  color: var(--secondary-color);
  padding-right: 24px;
}

.container-fluid.painel-usuario .btn-editar svg,
.container-fluid.painel-usuario .link-editar svg,
.container-fluid.painel-usuario .link-deletar svg {
  font-size: 14px;
  margin-bottom: 1px;
  margin-left: 2px;
  display: none;
  font-weight: bold;
}


.link-editar::before {
  content: '\f303';
  /* Font Awesome pencil icon */
  font-family: 'Font Awesome 5 Free';
  position: absolute;
  transition: all 0.3s ease-in-out;
  font-size: 15px;
  margin-top: 1px;
  background: linear-gradient(100deg, #ffffff00 0%, #ffffffff 28%, #ffffffff 100%);
  margin-left: 46px;
  padding-right: 50px;
  padding-left: 10px;
  font-weight: bold;
}

.link-editar:hover::before {
  animation: pencilEditAnimation 3.5s ease-in-out 3;
}

.container-fluid.painel-usuario .link-deletar {
  font: normal normal 300 16px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  padding: 0;
  color: #f70505;
  padding-right: 24px;
}

.link-deletar::before {
  content: '\f1f8';
  /* Font Awesome pencil icon */
  font-family: 'Font Awesome 5 Free';
  position: absolute;
  transition: all 0.3s ease-in-out;
  font-size: 15px;
  margin-top: 1px;
  background: linear-gradient(100deg, #ffffff00 0%, #ffffffff 28%, #ffffffff 100%);
  margin-left: 8rem;
  font-weight: bold;
  /* padding-right: 50px; */
  /* padding-left: 10px; */
}

.link-deletar:hover::before {
  /* animation: trashEditAnimation 3.5s ease-in-out 3; */
}

.container-fluid.painel-usuario .link-deletar:hover {
  text-decoration: none;
}

.container-fluid.painel-usuario .link-editar:hover {
  text-decoration: none;
}

.form-editando {
  font: normal normal bold 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #b5b5b5;

}

#confirmaSemDadosBancarios p {
  text-align: left;
  font: normal normal normal 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
}

#confirmaSemDadosBancarios button {
  text-align: left;
  font: normal normal bold 15px/18px 'Kanit', sans-serif;
  letter-spacing: 0px;
  height: 48px;
}

#confirmaSemDadosBancarios .modal-btn-voltar {
  border: none;
  background-color: #FFFFFF;
  border: 3px solid transparent;
  color: #4780f1;
}

#confirmaSemDadosBancarios .modal-btn-voltar:hover {
  border: 3px solid #4780f1;
}

#confirmaSemDadosBancarios .modal-btn-prosseguir {
  border: 3px solid #597EB5;
  background: #ffffff;
  color: #597EB5;
}

#confirmaSemDadosBancarios .modal-btn-prosseguir:hover {
  border: 3px solid #4780f1;
  background: #4780f1;
  color: #ffffff;

}</style>
